'use strict';

import angular from 'angular';
import ngCookies from 'angular-cookies';
import ngResource from 'angular-resource';
import ngSanitize from 'angular-sanitize';
import ngAnimate from 'angular-animate';

const ngRoute = require('angular-route');

import {routeConfig} from './app.config';

import account from './account';
import usuario from './usuario-route';
import articulo from './articulo-route';
import buscarArticulo from './buscar-articulo-route';
import carrito from './carrito-route';
import contacto from './contacto-route';
import descargas from './descargas-route';
import configuracion from './configuracion-route';
import ordenes from './ordenes-route';
import historial from './historial-route';
import categorias from './categorias-route';
import main from './main-route'

import _Auth from '../components/auth/auth.module';
import navbar from '../components/navbar/navbar.component';
import mainHeader from '../components/main-header/main-header.component';
import articuloComponent from '../components/articulo';
import carousel from '../components/carousel';
import footer from '../components/footer/footer.component';
import util from '../components/util/util.module';
import linkEditar from '../components/link-editar';
import articulosPagination from '../components/articulos-pagination';
import constants from './app.constants';

import toaster from 'angularjs-toaster';
import ngFileUpload from 'ng-file-upload';

import './app.css';


angular.module('pizzutoAutopartesApp', [
        ngCookies, ngResource, ngSanitize, ngRoute, ngAnimate,
        account, usuario, articulo, buscarArticulo, carrito, contacto, descargas, configuracion, main, ordenes, historial, categorias,
        _Auth, articuloComponent, navbar, carousel, mainHeader, footer, constants, util, linkEditar, articulosPagination,
        ngFileUpload, toaster
    ])
    .config(routeConfig)
    .run(function ($rootScope, $location, Auth) {
        'ngInject';
        // Redirect to login if route requires auth and you're not logged in

        $rootScope.$on('$routeChangeStart', function (event, next) {
            Auth.isLoggedIn(function (loggedIn) {
                // console.log('loggedIn?', loggedIn);
                // console.log('admin?', next.administrator);
                if (next.authenticate && !loggedIn || (next.administrator && loggedIn !== 'admin')) {
                    event.preventDefault();
                    $location.path('/');
                }
            });
        });
    });

angular.element(document)
    .ready(() => {
        angular.bootstrap(document, ['pizzutoAutopartesApp'], {
            strictDi: true
        });
    });



// WEBPACK FOOTER //
// ./client/app/app.js